(function ($) {
    'use strict';

    function initializeSlider() {
        // Initialize Slick Slider with autoplay
        $('#sliderVideos').slick({
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });



        const modal = $('#videoSliderModal');
        const videoPlayer = $('#videoPlayer');
        const modalTitle = $('#modalTitle');
        const slider = $('#sliderVideos'); // Cache slider for later use

        // Event delegation to handle clicks on dynamically loaded elements
        slider.on('click', '.slider-item', function () {
            const videoLink = $(this).find('.slider-image').data('video');  // Get video URL from data attribute
            const videoTitle = $(this).find('.slider-image').data('title'); // Get video title from data attribute

            if (videoLink) {
                videoPlayer.attr('src', videoLink);  // Set the iframe src to the video link
            }

            if (videoTitle) {
                modalTitle.text(videoTitle);  // Set the modal title
            }

            // Show the modal
            modal.modal('show');

            // Pause the Slick slider autoplay when modal is opened
            slider.slick('slickPause');
        });

        // Clear the iframe src to stop the video and resume autoplay when the modal is closed
        modal.on('hidden.bs.modal', function () {
            videoPlayer.attr('src', '');  // Clear the iframe src

            // Resume the Slick slider autoplay when modal is closed
            slider.slick('slickPlay');
        });
    }

    // Initialize Slick Slider when the DOM is fully loaded
    $(document).ready(function () {
        if ($('#sliderVideos').length > 0) {
            console.log('Initializing Slick on #sliderVideos');
            initializeSlider();
        } else {
            // Initialize observer to detect DOM changes (useful in dynamic Gutenberg environment)
            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    // If new nodes are added
                    if (mutation.addedNodes.length) {
                        // Check if any of the new nodes contain the slider
                        const slider = $('[data-type="acf/biocom-video-slider"]');
                        if (slider.length > 0) {
                            console.log('Slider found, initializing...');
                            console.log('Initializing Slick on #sliderVideos');
                            initializeSlider();
                            observer.disconnect(); // Stop observing once the slider is found
                        }
                    }
                });
            });

            // Start observing the body for changes in the DOM
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    });
})(jQuery);
